import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setWantGoogleMaps } from '../redux/actions/applicationActions'
import { MapPrivacyPolicy } from 'components/molecules'
import { getCookieValueByName } from 'settings/app/helpers'

const useMapPrivacyPolicy = () => {
  const wantGoogleMaps = useSelector(
    (state) => state.application.wantGoogleMaps
  )
  const dispatchWantGoogleMaps = useDispatch()

  React.useEffect(() => {
    const wantGoogleMapsCookie = getCookieValueByName('wantGoogleMaps')
    if (wantGoogleMapsCookie) {
      dispatchWantGoogleMaps(setWantGoogleMaps(true))
    }
  }, [dispatchWantGoogleMaps])

  const onActivateClick = () => {
    // if cookie comfort layer enabled save maps cookie
    if (
      typeof window.CookieSettingsManager === 'object' &&
      window.CookieSettingsManager.getStatusForCategory('comfort')
    ) {
      // cookie expires in 30 days
      const expiresAt = new Date()
      expiresAt.setDate(expiresAt.getDate() + 30)
      document.cookie = `wantGoogleMaps=true; expires=${ expiresAt.toUTCString() }; path=/`
    }
    dispatchWantGoogleMaps(setWantGoogleMaps(true))
  }

  return {
    wantGoogleMaps,
    MapPrivacyPolicy: () => (
      <MapPrivacyPolicy onActivateClick={ onActivateClick } />
    ),
  }
}

export default useMapPrivacyPolicy
